export default __webpack_public_path__ + "static/media/drink8.d8e959e9.jpg";